import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PauseCircleIconSvg from './icon-pause-circle.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PauseCircleIconSvg {...validProps} />;
}
SvgComponent.iconName = 'pause-circleIcon';

/**
 * @deprecated This is a legacy icon
 */
export const PauseCircleIcon = svgIconWrapper(SvgComponent);
